import React from "react"
import styled from "styled-components"
import { uiColorToBaseColor } from "styleguide/styles/colors"
import media from "styleguide/styles/media-queries"
import DocSidebar from "styleguide/page-components/DocArticle/DocSidebar"

const StyledSidebarCol = styled.div`
  background-color: ${uiColorToBaseColor("veryLightBlue")};
  padding: 80px 0 0 0;
  position: fixed;
  left: 0;
  width: calc(25% - 32px);
  box-sizing: border-box;
  top: 0;
  z-index: 99;
  height: 100vh;

  ${media.desktop`
    width: calc(33.333% - 32px);
   `}

  ${media.tablet`
    display: none;
  `}
`

interface Props {
  children: React.ReactNode
  repoName: string
  mdxName: string
  currentSlug: string
  categories: string[]
  articles: any
}

const DocSidebarPersistent = ({ children, repoName, mdxName, currentSlug, categories, articles }: Props) => (
  <>
    <StyledSidebarCol>
      <DocSidebar
        repoName={repoName}
        mdxName={mdxName}
        currentSlug={currentSlug}
        articles={articles}
        categories={categories}
      />
    </StyledSidebarCol>
    {children}
  </>
)

export default DocSidebarPersistent
